import { updateUserOptions } from 'owa-options-core';
import { updateUserConfiguration } from 'owa-options-core';
import getKeyboardShortcutsOptions from '../data/store/store';

export default async function saveKeyboardShortcutsOption() {
    let optionState = getKeyboardShortcutsOptions();

    updateUserOptions({
        KeyboardShortcutsMode: optionState.shortcuts,
    });

    await updateUserConfiguration([
        {
            propertyName: 'KeyboardShortcutsMode',
            propertyType: 'Integer32',
            propertyValue: `${optionState.shortcuts}`,
        },
    ]);
}
